'use strict';

require('babel-polyfill');
//
// // include all the specs
require('./specs/hello');
require('./specs/modules');
